import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!

  return (_openBlock(), _createBlock(_component_q_btn_group, { rounded: "" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createBlock(_component_q_btn, {
          key: option.value,
          color: _ctx.getColor(option.value),
          label: option.label,
          onClick: ($event: any) => (_ctx.select(option.value))
        }, null, 8, ["color", "label", "onClick"]))
      }), 128))
    ]),
    _: 1
  }))
}